var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOpencorporates = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#22262A",
    strokeWidth: 1.339,
    d: "M13 25c6.627 0 12-5.373 12-12S19.627 1 13 1 1 6.373 1 13s5.373 12 12 12Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#22262A",
    d: "M20.473 14.658v-.883l-1.084.587c-1.347.349-2.35.035-3.04-.587-.76-.686-.934-1.215-.957-2.553-.029-1.593.316-2.456 1.446-3.325.38-.291 1.437-.349 1.897 0v1.406c.658.675 1.97.022 1.738-.842-.193-.719-.744-1.186-1.08-1.277a5.4 5.4 0 0 0-2.893 0c-1.852.788-2.649 1.732-2.649 4.226.103 3.126 1.983 4.063 3.923 4.113.572 0 1.736-.222 2.699-.865"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#22262A",
    fillRule: "evenodd",
    d: "M5.5 11.086c0-2.013 1.507-4.191 4.003-4.191 1.894 0 3.961 1.349 3.961 4.191 0 3.286-2.055 4.475-3.96 4.475-2.495 0-4.004-1.83-4.004-4.475m1.602 0c0-1.783.917-3.39 2.401-3.39 1.557 0 2.402 1.827 2.402 3.39 0 2.669-1.14 3.739-2.402 3.739-1.455 0-2.401-1.464-2.401-3.739",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#22262A",
    strokeLinecap: "round",
    strokeWidth: 0.076,
    d: "M20.473 14.658v-.883l-1.084.587c-1.347.349-2.35.035-3.04-.587-.76-.686-.934-1.215-.957-2.553-.029-1.593.316-2.456 1.446-3.325.38-.291 1.437-.349 1.897 0v1.406c.658.675 1.97.022 1.738-.842-.193-.719-.744-1.186-1.08-1.277a5.4 5.4 0 0 0-2.893 0c-1.852.788-2.649 1.732-2.649 4.226.103 3.126 1.983 4.063 3.923 4.113.572 0 1.736-.222 2.699-.865Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#22262A",
    strokeLinecap: "round",
    strokeWidth: 0.076,
    d: "M5.5 11.086c0-2.013 1.507-4.191 4.003-4.191 1.894 0 3.961 1.349 3.961 4.191 0 3.286-2.055 4.475-3.96 4.475-2.495 0-4.004-1.83-4.004-4.475Zm1.602 0c0-1.783.917-3.39 2.401-3.39 1.557 0 2.402 1.827 2.402 3.39 0 2.669-1.14 3.739-2.402 3.739-1.455 0-2.401-1.464-2.401-3.739Z",
    clipRule: "evenodd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.947,
    cy: 18.306,
    r: 0.802,
    fill: "#22262A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.299,
    cy: 18.306,
    r: 0.802,
    fill: "#22262A"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.65,
    cy: 18.306,
    r: 0.802,
    fill: "#22262A"
  })));
};
export default SvgOpencorporates;